import { getUrlVars } from "../../utils/Url";
/**
 * Podcast service - retreives a json file based on url paramater.
 * i.e. : "<url>/?show=<url to json>"
 *
 * To use dummy file for local dev
 * without cors: http://localhost:8000/?show=dummy-frankwatching.json
 */

export default class PodcastService {
  async getPodCast(element) {
    const items = getUrlVars().items;
    const playlistItemsUrl = getUrlVars().playlistItemsUrl;
    const sponsoredShowUrl =
      getUrlVars().show ||
      getUrlVars().podcast ||
      element.getAttribute("data-json");

    if (!items && !playlistItemsUrl) {
      return await fetch(sponsoredShowUrl, {
        headers: new Headers({
          accept: "application/json",
          "content-type": "application/json"
        })
      })
        .then(response => response.json())
        .then(response => {
          return {
            isCustomPlaylist: false,
            episodes: response
          };
        });
    } else if (items && items.length) {
      const body = items.split(",");

      return await fetch(playlistItemsUrl, {
        method: "POST",
        headers: new Headers({
          accept: "application/json",
          "content-type": "application/json"
        }),
        body: JSON.stringify(body)
      })
        .then(response => response.json())
        .then(response => {
          return {
            isCustomPlaylist: true,
            episodes: response
          };
        });
    } else {
      alert("no items");
    }
  }
}
